<div mdbModal #videoRecorderModal="mdbModal" class="modal fade scrollable" tabindex="-1" id="previewModal" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true"
     [config]="{backdrop: 'static',  keyboard: false, overflowScroll: true}">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="hideModal()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">Record Video</h4>
      </div>
      <div class="modal-body">
        <div class="row" *ngIf="sectionText">
          <div class="col-md-12">
            <p class="section-text">{{sectionText}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center" *ngIf="!videoCantStart">
              <h3>
                <video #videoElement class="video-container" [class.fade-video]="preVideoCountdown" [muted]="videoMuted">
                  <source *ngIf="!isVideoRecording && videoBlobUrl" [src]="videoBlobUrl">
                </video>
              </h3>
              <div class="record-starting-text" *ngIf="preVideoCountdown">Recording begins in {{startSeconds}}...</div>
            </div>

            <div class="failed-video-container" *ngIf="videoCantStart">
              <div class="failed-video-content">
                <i class="far fa-exclamation-triangle video-error-icon"></i> <br />
                Your camera is either unavailable or this site does not have permission to use it. Please check your device's settings, grant permission for this site to use the camera or refresh and try again.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <span class="video-timer mr-auto" *ngIf="isVideoRecording && !videoBlobUrl"> {{ videoRecordedTime }} / {{formattedMaxRecordTimeInSeconds}} </span>

        <button *ngIf="!videoCantStart && preVideoCountdown" type="button" mdbBtn class="btn btn-danger" aria-label="Stop" (click)="stopVideoRecording()" mdbWavesEffect><i class="fad fa-stop"></i>&nbsp; Stop</button>

        <button *ngIf="!videoCantStart && !isVideoRecording && !videoBlobUrl && !preVideoCountdown" type="button" mdbBtn class="btn btn-primary" aria-label="Start Recording" (click)="startVideoRecording()" mdbWavesEffect><i class="far fa-video"></i>&nbsp; Start Recording</button>
        <button *ngIf="!videoCantStart && isVideoRecording && !videoBlobUrl && !preVideoCountdown" type="button" mdbBtn class="btn btn-danger" aria-label="Stop Recording" (click)="stopVideoRecording()" mdbWavesEffect><i class="fad fa-stop"></i>&nbsp; Stop Recording</button>

        <button *ngIf="!videoCantStart && !isVideoRecording && videoBlobUrl" type="button" mdbBtn class="btn btn-default" aria-label="Start Over" (click)="clearVideoRecordedData(true)" mdbWavesEffect><i class="far fa-redo"></i>&nbsp; Start Over</button>
        <button *ngIf="!videoCantStart && !isVideoRecording && videoBlobUrl" type="button" mdbBtn class="btn btn-primary" aria-label="Done" (click)="completeVideo()" mdbWavesEffect>Done</button>

        <button *ngIf="videoCantStart" type="button" mdbBtn class="btn btn-default" aria-label="Close" (click)="hideModal()" mdbWavesEffect>Close</button>
      </div>
    </div>
  </div>
</div>
